import { render, staticRenderFns } from "./roleUser.vue?vue&type=template&id=345751b8&scoped=true&"
import script from "./roleUser.vue?vue&type=script&lang=js&"
export * from "./roleUser.vue?vue&type=script&lang=js&"
import style0 from "./roleUser.vue?vue&type=style&index=0&id=345751b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345751b8",
  null
  
)

export default component.exports